'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeFedopsApps = initializeFedopsApps;
exports.getAppLoadingPhaseData = getAppLoadingPhaseData;
exports.setAppLoadingPhaseData = setAppLoadingPhaseData;
exports.getStartLoadTime = getStartLoadTime;

var _env = require('../env');

/**
 * env().fedops.apps wrapper
 */
function initializeFedopsApps() {
  (0, _env.env)().fedops = (0, _env.env)().fedops || {};
  (0, _env.env)().fedops.apps = (0, _env.env)().fedops.apps || {};
}

function getAppData(appName) {
  return (((0, _env.env)().fedops || {}).apps || {})[appName];
}

function getAppLoadingPhaseData(appName) {
  var data = getAppData(appName);
  return data ? data.appLoadingPhaseData : null;
}

function setAppLoadingPhaseData(appName, phaseData) {
  var apps = (0, _env.env)().fedops.apps;
  apps[appName] = apps[appName] || {};
  apps[appName].appLoadingPhaseData = phaseData;
}

function getStartLoadTime(appName) {
  return (getAppData(appName) || {}).startLoadTime || 0;
}

exports.default = {
  initApp: function initApp(appName) {
    (0, _env.env)().fedops.apps[appName] = (0, _env.env)().fedops.apps[appName] || {};
  },
  getStartLoadTime: function getStartLoadTime(appName) {
    var appData = getAppData(appName);
    if (!appData) {
      return null;
    }
    return appData.startLoadTime;
  },
  setStartLoadTime: function setStartLoadTime(appName, startLoadTime) {
    return getAppData(appName).startLoadTime = startLoadTime;
  }
};